import React, {Dispatch, SetStateAction, useCallback} from 'react';

import {FilterInput} from 'src/components/input';
import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';
import StateButton from '@pb/kit-component-state-button';
import Typography from '@pb/kit-component-typography';

import {SidebarSection} from './sidebar-section';

import type {SortDirection} from 'src/openapi/admin/models/SortDirection';


type Props = {
    isActiveOnly: boolean,
    onActiveOnlyToggle: Dispatch<SetStateAction<boolean>>,
    titleFilter: string,
    onTitleFilterChange: (titleFilter: string) => void,
    dateSortDirection: SortDirection,
    onSort: (sortDirection: SortDirection) => void,
};

const SORT_FILTER_ID = 'internal-notifications-sort-combobox';
const TITLE_FILTER_ID = 'internal-notifications-title-filter';

export const Filters = (props: Props) => {
    const {titleFilter, onTitleFilterChange, dateSortDirection, onSort, onActiveOnlyToggle, isActiveOnly} = props;
    const clearTitleFilter = useCallback(() => onTitleFilterChange(''), [onTitleFilterChange]);

    const toggleActiveOnly = useCallback(() => {
        onActiveOnlyToggle(prevState => !prevState);
    }, [onActiveOnlyToggle]);

    return (
        <SidebarSection>
            <Group gap="m" direction="v" className="pdx-m">
                <Typography fontWeight="semi-bold" variant="heading-level-3">Filters</Typography>
                <FilterInput
                    id={TITLE_FILTER_ID}
                    value={titleFilter}
                    onChange={onTitleFilterChange}
                    onClear={clearTitleFilter}
                    timeOut={10}
                    placeholder="Search notification by title"
                />
                <div>
                    <Label htmlFor={SORT_FILTER_ID}>Sort</Label>
                    <ComboBox id={SORT_FILTER_ID} value={dateSortDirection} onChange={onSort}>
                        <ComboboxItem caption="Newest to Oldest" value={SortDirections.DESC}/>
                        <ComboboxItem caption="Oldest to Newest" value={SortDirections.ASC}/>
                    </ComboBox>
                </div>

                <Group alignItems="center">
                    <Label>Show only recent</Label>
                    <StateButton
                        {...{
                            name: 'active-only',
                            checked: isActiveOnly,
                            onChange: toggleActiveOnly,
                        }}
                    />
                </Group>
            </Group>
        </SidebarSection>
    );
};
